import React, { useState, useRef, useEffect } from 'react';
import './StockMovementEdit.scss';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import { Link } from 'react-router-dom';
const statusColors = {
  'unavailable': 'unavailable',
  'Sold out': 'soldout',
  'In stock': 'instock',
  'Limited': 'limited',
  'Successful': 'successful',
};

const initialProducts = [
  { id: '#232132135612', name: 'E-marketing A1', category: 'Social media', quantity: '20/11', price: 'EGP.120,000.00', status: 'unavailable' },
  { id: '#232132135612', name: 'E-marketing A2', category: 'Social media', quantity: '20/11', price: 'EGP.120,000.00', status: 'Sold out' },
  { id: '#232132135612', name: 'E-marketing B1', category: 'Social media', quantity: '20/11', price: 'EGP.120,000.00', status: 'In stock' },
  { id: '#232132135612', name: 'E-marketing B2', category: 'Social media', quantity: '20/11', price: 'EGP.120,000.00', status: 'In stock' },
  { id: '#232132135612', name: 'E-marketing B3', category: 'Social media', quantity: '20/11', price: 'EGP.120,000.00', status: 'In stock' },
  { id: '#232132135612', name: 'E-marketing C1', category: 'Social media', quantity: '20/11', price: 'EGP.120,000.00', status: 'unavailable' },
  { id: '#232132135612', name: 'E-marketing Book', category: 'Social media', quantity: '20/11', price: 'EGP.120,000.00', status: 'Sold out' },
  { id: '#232132135612', name: 'Interface design', category: 'E-book', quantity: '20/11', price: 'EGP.120,000.00', status: 'In stock' },
  { id: '#232132135612', name: 'Programming', category: 'E-book', quantity: '20/11', price: 'EGP.120,000.00', status: 'In stock' },
  { id: '#232132135612', name: 'Marketing Secrets', category: 'E-book', quantity: '20/11', price: 'EGP.120,000.00', status: 'Sold out' },
  { id: '#232132135612', name: 'Small projects', category: 'E-book', quantity: '20/11', price: 'EGP.120,000.00', status: 'In stock' },
  { id: '#232132135612', name: 'The right start', category: 'E-book', quantity: '20/11', price: 'EGP.120,000.00', status: 'In stock' },
  { id: '#232132135612', name: 'Browser Protection', category: 'Software', quantity: '20/11', price: 'EGP.120,000.00', status: 'unavailable' },
  { id: '#232132135612', name: 'Windows 11', category: 'Software', quantity: '20/11', price: 'EGP.120,000.00', status: 'In stock' },
  { id: '#232132135612', name: 'Marketing Secrets', category: 'E-book', quantity: '20/11', price: 'EGP.120,000.00', status: 'Sold out' },
];

export default function StockMovementEdit() {
  const [openedDropdown, setOpenedDropdown] = useState(null);
  const dotsRefs = useRef([]);

  useEffect(() => {
    function handleClickOutside(event) {
      dotsRefs.current.forEach((ref, idx) => {
        if (ref && !ref.contains(event.target)) {
          if (openedDropdown === idx) setOpenedDropdown(null);
        }
      });
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [openedDropdown]);

  return (
    <div className="stock-movement-edit-container">
   <div className="headerr">
  <div className="stock-filters">
    <button className="stock-filter active">24 Hour</button>
    <button className="stock-filter">7 Days</button>
    <button className="stock-filter">30 Days</button>
    <button className="stock-filter">12 Months</button>
  </div>

  <div className="search-wrapper">
    <input
      type="text"
      placeholder="Search by order id"
      className="stock-search"
    />
    <i className="fa-solid fa-magnifying-glass search-icon"></i>
  </div>

  <div className="stock-header">
    <div className="stock-actions">
      <Link to="/dashboard/AddNewProductss">
            <button className="stock-btn blue">Add New Product</button>
      </Link>
<Link to="/dashboard/AddNewservieses">
 <button className="stock-btn">Add New Service</button>
</Link>
     
    </div>
  </div>
</div>


    
      <div className="stock-table-wrapper">
        <table className="stock-table">
          <thead>
            <tr>
              <th>Product ID</th>
              <th>Product Name</th>
              <th>Category</th>
              <th>Quantity</th>
              <th>Per.Price</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {initialProducts.map((row, idx) => (
              <tr key={idx}>
                <td>{row.id}</td>
                <td>{row.name}</td>
                <td>{row.category}</td>
                <td>{row.quantity}</td>
                <td>{row.price}</td>
                <td>
                  <span className={`stock-status ${statusColors[row.status]}`}>{row.status}</span>
                </td>
                <td>
                  <div className="dots-wrapper" ref={el => dotsRefs.current[idx] = el}>
                    <button className="dots-menu-btn" onClick={() => setOpenedDropdown(openedDropdown === idx ? null : idx)}>...</button>
                    {openedDropdown === idx && (
                      <div className="dropdown-menu">
                        <Link to="/dashboard/EditProduct">
                                                <button><FiEdit2 /> Edit title & description</button>
</Link>
                        <button>Publish</button>
                        <button>Feedbacks</button>
                        <button className="delete"><FiTrash2 /> Delete forever</button>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="stock-pagination">
        <span>Showing 1-17 of 100</span>
        <div className="pagination-btns">
          <button>{'<'}</button>
          <button className="active">1</button>
          <button>2</button>
          <button>3</button>
          <button>4</button>
          <button>{'>'}</button>
        </div>
      </div>
    </div>
  );
} 